const selectors = {
  byParentWithScope: (state, parentType, parentId, scope) => (
    state.apiv3.privacyCode.id.find(p => p.parentType === parentType && p.parentId === parentId && p.scope === scope)
  )
}

export {
  selectors as privacyCodeSelectors
}
